import React from 'react';
import PermissionMatrix from './PermissionMatrix';

const Compliance = (props) => (
  <PermissionMatrix {...props} areaLabel="Compliance" hierarchy={['Diretor', 'Gerente', 'Analista', 'Estagiário']} />
);

export default Compliance;
